export default "__VITE_ASSET__C9XFyONa__"